module.exports = __webpack_public_path__ + "images/shuffle@3x.png?2e8343e5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shuffle@3x.png
// module id = 703
// module chunks = 7